import api from "./api";

const TEMPLATE_BASE = "/sms-templates";
const LOC_BASE = "/locations";

const smsTemplateService = {
  // ── SMS Folders ──
  listFolders: async (locationId) => {
    return api.get(`${TEMPLATE_BASE}/folders?locationId=${locationId}`);
  },
  createFolder: async ({ name, locationId }) => {
    return api.post(`${TEMPLATE_BASE}/folders`, { name, locationId });
  },
  renameFolder: async (id, { name }) => {
    return api.patch(`${TEMPLATE_BASE}/folders/${id}`, { name });
  },
  deleteFolder: async (id) => {
    return api.delete(`${TEMPLATE_BASE}/folders/${id}`);
  },

  // ── SMS Templates ──
  listTemplates: async (folderId) => {
    return api.get(`${TEMPLATE_BASE}?folderId=${folderId}`);
  },
  createTemplate: async ({ title, body, folderId, locationId }) => {
    return api.post(TEMPLATE_BASE, { title, body, folderId, locationId });
  },
  updateTemplate: async (id, data) => {
    return api.patch(`${TEMPLATE_BASE}/${id}`, data);
  },
  deleteTemplate: async (id) => {
    return api.delete(`${TEMPLATE_BASE}/${id}`);
  },

  // ── Aggregated: folders + templates for a location ──
  getFoldersByLocation: async (locationId) => {
    return api.get(`${TEMPLATE_BASE}/by-location?locationId=${locationId}`);
  },

  // ── Voicemail ──
  uploadVoicemail: async (formData) => {
    return api.post(`${LOC_BASE}/voicemail/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  deleteVoicemail: async ({ locationIds, voicemailUrl }) => {
    return api.delete(`${LOC_BASE}/voicemail/delete`, {
      data: { locationIds, voicemailUrl },
    });
  },
  getMissedCallTemplates: async (locationId) => {
    return api.get(`${LOC_BASE}/${locationId}/missed-call-templates`);
  },
  updateMissedCallActions: async (locationId, actions) => {
    return api.patch(`${LOC_BASE}/${locationId}/missed-call-actions`, {
      missedCallActions: actions,
    });
  },
};

export default smsTemplateService;
